import React from 'react';
import { Layout } from 'fronton-react';
import { RootLayout } from 'common/components';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  FeaturesSection,
  GallerySection,
  HeaderSection,
  ProjectDevelopmentSection,
  ProjectServicesTypesSection,
  STEPS_LIST,
  StepsSection,
} from '../components';
import {
  DEFAULT_CONSULTATION_SECTION_TITLE,
  DEFAULT_CONSULTATION_SUB_CHANNEL,
} from '../engineering-systems-constants';
import { EngineeringSystemTypeProps } from '../engineering-systems-types';
import { HEATING_GALLERY_LIST } from './components/gallery-section';
import { HEATING_HEADER_SECTION_CONFIG } from './components/header-section';
import { HEATING_PROJECT_TYPE_LIST, HEATING_PROJECT_DEVELOPMENT } from './components/project-types-section';
import {
  HEATING_ELEMENT_BLOCK,
  HEATING_SYSTEMS_CONSULTATION_TYPE,
  HEATING_SYSTEMS_PATH,
} from './heating-systems-constants';

/**
 * Вью страницы "Системы отопления"
 */
export const HeatingSystems = ({
  consultationSectionRef,
  onConsultationSignupBtnClick,
  serviceTypePrice,
}: EngineeringSystemTypeProps) => (
  <RootLayout currentPage={HEATING_SYSTEMS_PATH}>
    <Layout>
      <HeaderSection
        headerConfig={HEATING_HEADER_SECTION_CONFIG}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <FeaturesSection />
      <PromoBlock elementBlock={HEATING_ELEMENT_BLOCK} />
      <SpecialOffer onModalBtnClick={onConsultationSignupBtnClick} elementBlock={HEATING_ELEMENT_BLOCK} />
      {serviceTypePrice && Object.keys(serviceTypePrice).length > 1 ? (
        <ProjectServicesTypesSection
          elementBlock={HEATING_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectTypeList={HEATING_PROJECT_TYPE_LIST}
          serviceTypePrice={serviceTypePrice}
        />
      ) : (
        <ProjectDevelopmentSection
          elementBlock={HEATING_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectDevelopmentInfo={HEATING_PROJECT_DEVELOPMENT}
          serviceTypePrice={serviceTypePrice}
        />
      )}
      <StepsSection stepSectionList={STEPS_LIST} />
      <GallerySection
        elementBlock={HEATING_ELEMENT_BLOCK}
        galleryList={HEATING_GALLERY_LIST}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <ConsultationSection
        consultationType={HEATING_SYSTEMS_CONSULTATION_TYPE}
        elementBlock={HEATING_ELEMENT_BLOCK}
        elementText="Заявка на консультацию"
        sectionRef={consultationSectionRef}
        sectionTitle={DEFAULT_CONSULTATION_SECTION_TITLE}
        subChannel={DEFAULT_CONSULTATION_SUB_CHANNEL}
      />
    </Layout>
  </RootLayout>
);
